import request from '@/services/request'
import baseUrl from '@/services/baseUrl'

const path = `${baseUrl.main}/cs/v1/`

export default {
  getResponses: (params = {}) => request.post(path + 'services/survey/bo/list', params),
  exportResponses: (params = {}) => request.post(path + 'services/survey/bo/export', params),
  getResponse: id => request.post(path + 'services/survey/bo/detail/' + id),
  deleteResponse: id => request.post(path + 'services/survey/bo/delete/' + id),
}
